/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_FortifiedInputs */

const en_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortified`)
};

const es_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortificado`)
};

const fr_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muté`)
};

const de_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespritzt/Likörwein`)
};

const ja_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`酒精強化ワイン`)
};

const zh_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加强酒`)
};

const ar_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبيذ مقوى`)
};

const id_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diperkuat`)
};

const it_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vino Fortificato`)
};

const ru_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Крепленое`)
};

const pt_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortificado`)
};

const ko_val_fortified = /** @type {(inputs: Val_FortifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주정 강화`)
};

/**
* | output |
* | --- |
* | "Fortified" |
*
* @param {Val_FortifiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_fortified = /** @type {((inputs?: Val_FortifiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_FortifiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_fortified(inputs)
	if (locale === "es") return es_val_fortified(inputs)
	if (locale === "fr") return fr_val_fortified(inputs)
	if (locale === "de") return de_val_fortified(inputs)
	if (locale === "ja") return ja_val_fortified(inputs)
	if (locale === "zh") return zh_val_fortified(inputs)
	if (locale === "ar") return ar_val_fortified(inputs)
	if (locale === "id") return id_val_fortified(inputs)
	if (locale === "it") return it_val_fortified(inputs)
	if (locale === "ru") return ru_val_fortified(inputs)
	if (locale === "pt") return pt_val_fortified(inputs)
	return ko_val_fortified(inputs)
});